<div #reCaptchaWrapperElement></div>
@if (erroneous) {
    <div class="text-danger">{{ errorMessage }}</div>
}
